import React, { useEffect, useCallback } from 'react';
import { useTranslation } from "../../context/TranslationContext";
import { useWebSocket } from '../../context/WebSocketContext';
import { useNavigate } from "react-router-dom";
import { ConnectionEventEmitter } from '../../utils/ConnectionEventEmitter';
import List from "../../components/List";
import log from "loglevel";

import '../../styles/Host.css'; 

function HostRestaurants() {
  const { t, language } = useTranslation();
  const { sendMessage, isConnected } = useWebSocket();
  const navigate = useNavigate();

  const list = {
    "elements": [
      {
        "id": 1,
        "name": {
          "pl": "Restauracja La Perla",
          "en": "La Perla Restaurant",
          "de": "Restaurant La Perla"
        },
        "slogan": {
          "pl": "Najlepsze owoce morza w Alicante!",
          "en": "The best seafood in Alicante!",
          "de": "Die besten Meeresfrüchte in Alicante!"
        },
        "address": {
          "city": "Alicante",
          "street": "Calle Mayor 12",
          "postal_code": "03001",
          "google_maps_link": "https://www.google.com/maps?q=38.3452,-0.4813",
          "latitude": 38.3452,
          "longitude": -0.4813,
          "full_address": "Calle Mayor 12, 03001 Alicante, Spain"
        },
        "icon": "https://example.com/icons/la_perla.png"
      },
      {
        "id": 2,
        "name": {
          "pl": "El Puerto",
          "en": "The Port",
          "de": "Der Hafen"
        },
        "slogan": {
          "pl": "Świeże ryby prosto z portu!",
          "en": "Fresh fish straight from the port!",
          "de": "Frischer Fisch direkt aus dem Hafen!"
        },
        "address": {
          "city": "Benidorm",
          "street": "Av. del Mediterráneo 23",
          "postal_code": "03503",
          "google_maps_link": "https://www.google.com/maps?q=38.5382,-0.1313",
          "latitude": 38.5382,
          "longitude": -0.1313,
          "full_address": "Av. del Mediterráneo 23, 03503 Benidorm, Spain"
        },
        "icon": "https://example.com/icons/el_puerto.png"
      },
      {
        "id": 3,
        "name": {
          "pl": "Tapas y Vino",
          "en": "Tapas & Wine",
          "de": "Tapas & Wein"
        },
        "slogan": {
          "pl": "Tradycyjne hiszpańskie tapas i wina",
          "en": "Traditional Spanish tapas and wines",
          "de": "Traditionelle spanische Tapas und Weine"
        },
        "address": {
          "city": "Calpe",
          "street": "Carrer de la Mar 5",
          "postal_code": "03710",
          "google_maps_link": "https://www.google.com/maps?q=38.6455,0.0441",
          "latitude": 38.6455,
          "longitude": 0.0441,
          "full_address": "Carrer de la Mar 5, 03710 Calpe, Spain"
        },
        "icon": "https://example.com/icons/tapas_vino.png"
      },
      {
        "id": 4,
        "name": {
          "pl": "Paella del Sol",
          "en": "Sun Paella",
          "de": "Sonne Paella"
        },
        "slogan": {
          "pl": "Najlepsza paella na Costa Blanca!",
          "en": "The best paella on Costa Blanca!",
          "de": "Die beste Paella an der Costa Blanca!"
        },
        "address": {
          "city": "Altea",
          "street": "Plaza de la Iglesia 8",
          "postal_code": "03590",
          "google_maps_link": "https://www.google.com/maps?q=38.5986,-0.0514",
          "latitude": 38.5986,
          "longitude": -0.0514,
          "full_address": "Plaza de la Iglesia 8, 03590 Altea, Spain"
        },
        "icon": "https://example.com/icons/paella_del_sol.png"
      },
      {
        "id": 5,
        "name": {
          "pl": "Casa del Jamón",
          "en": "House of Ham",
          "de": "Haus des Schinkens"
        },
        "slogan": {
          "pl": "Autentyczne jamón ibérico i sery",
          "en": "Authentic jamón ibérico and cheeses",
          "de": "Authentischer iberischer Schinken und Käse"
        },
        "address": {
          "city": "Torrevieja",
          "street": "Calle Ramón Gallud 45",
          "postal_code": "03181",
          "google_maps_link": "https://www.google.com/maps?q=37.9788,-0.6822",
          "latitude": 37.9788,
          "longitude": -0.6822,
          "full_address": "Calle Ramón Gallud 45, 03181 Torrevieja, Spain"
        },
        "icon": "https://example.com/icons/casa_del_jamon.png"
      }
    ]
  }

  const connectionOpened = useCallback(() => {
    log.debug('Restaurants connectionOpened');
  }, []);

  const connectionClosed = useCallback(() => {
    log.debug('Restaurants connectionClosed');
  }, []);

  const connectionReceived = useCallback((receivedMessage) => {
    if(receivedMessage) {
      log.debug('Restaurants received message:', receivedMessage);
    }
  }, []);

  const handleBack = () => {
    navigate('/host'); 
  };

  const handleAdd = () => {
    console.log("Add button clicked");
  };

  const getLabel = (item) => {
    return item.name[language];
  };

  const getDescription = (item) => {
    return item.address.city + " - " + item.slogan[language];
  };

  useEffect(() => {    
    ConnectionEventEmitter.on('opened', connectionOpened);
    ConnectionEventEmitter.on('closed', connectionClosed);
    ConnectionEventEmitter.on('received', connectionReceived);
    return () => { 
      ConnectionEventEmitter.off('opened', connectionOpened);
      ConnectionEventEmitter.off('closed', connectionClosed);
      ConnectionEventEmitter.off('received', connectionReceived);
    }
  }, []);

  return (
    <List list={list} id="restaurants" title={t.host.Restaurants} onBack={handleBack} onAdd={handleAdd} getLabel={getLabel} getDescription={getDescription}></List>
  );
}

export default HostRestaurants;